import React, {useEffect, useState} from "react";
import {
  Form,
  Checkbox,
  Input,
  Dropdown,
  Space,
  Select,
  Button,
  DatePicker,
} from "antd";
import "./ItemInput.scss";
import response from "../../../../config/data.json";

import type {CheckboxValueType} from "antd/es/checkbox/Group";
const ItemInput = props => {
  let {name, label, type, values, otherType, formRef} = props;
  const [options, setOptions] = useState<any[]>();
  const [checkedList, setCheckedList] = useState<any[]>([]);
  // const data = response.catalog;
  const data: any = null;
  useEffect(() => {
    getInitialValue();

    if (type == "dropdown" || type == "array_checkbox") {
      getOptions();
    }
  }, []);
  useEffect(() => {
    if (type == "array_checkbox" && checkedList.length > 0) {
      setFieldValue(checkedList);
    }
  }, [checkedList]);
  const getOptions = () => {
    if (type == "dropdown" || type == "array_checkbox") {
      values = values?.map((value, index) => {
        return {
          value: value,
          label: value,
        };
      });
    }
    setOptions([...values]);
  };
  const getInitialValue = () => {
    if (data) {
    }
  };

  const setFieldValue = value => {
    formRef.current.setFieldValue(name, value);
    // formRef.current.setFieldsValue({
    //   [name[0]]: {[name[1]]: {[name[2]]: value}},
    // });
  };

  const renderFormItem = () => {
    if (type == "other") {
      type = otherType.type;
    }
    switch (type) {
      case "input":
        // return <div>123</div>;
        return <Input placeholder="Nhập"></Input>;
      case "date":
        return <DatePicker showTime format={"hh:mm DD/MM/YY"}></DatePicker>;
      case "array_checkbox":
        return (
          <Checkbox.Group
            options={options}
            onChange={(checkedValues: CheckboxValueType[]) => {
              if (formRef) {
                setCheckedList(checkedValues);
              }
            }}
          ></Checkbox.Group>
        );
      case "dropdown":
        return (
          <Select
            allowClear
            placeholder="Chọn"
            options={options}
            onChange={value => {
              setFieldValue(value);
            }}
          ></Select>
        );
      default:
        break;
    }
  };
  return (
    <Form.Item className="item-input" label={otherType?.title} name={name}>
      {renderFormItem()}
    </Form.Item>
  );
};
export default ItemInput;
